// Libarary Class
import * as $ from 'jquery';
import { Router, ActivatedRoute } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { NgSelectComponent } from '@ng-select/ng-select';
import { SelectionModel } from '@angular/cdk/collections';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';
import { MatTabChangeEvent } from '@angular/material/tabs';
import { Component, Inject, AfterViewInit, ElementRef, OnInit, ViewChild, OnDestroy, HostListener } from '@angular/core';
const _ = require('lodash');
// Service Class
import { BroadcastService } from './../../../../services/infrastructure/broadcaster.service';
import { ConfigService } from './../../../../services/infrastructure/config.service';
import { DashboardService } from './../../../../services/seed/dashboard.service';
import { GrowerOrderService } from './../../../../services/seed/growerOrder.service';
import { LoaderService } from './../../../../services/infrastructure/loader.service';
import { LocalStorageService } from './../../../../services/infrastructure/local-storage.service';
import { CommonService } from './../../../../services/common/common.service';

// Class
import { DashboardFilter } from './../../../../models/DashboardFilter';
import { GrowerOrderData } from './../../../../models/GrowerOrderData';
import { DealerOrderData } from './../../../../models/DealerOrderData';
import { MasterConstants } from './../../../../common/constants/master-constants';
import { SeedReplantService } from '../../../../services/seed/seed-replant/seed-replant.service';
import { Subscription } from 'rxjs';
import { LolLoggerService } from '../../../../common/shared/lol-logger.service';
import { GrowerPdfGenerate } from '../grower/grower-pdf-generate/grower-pdf-generate.component';
// declare var submitActionToDTM: any;

@Component({
  selector: 'app-landing-data',
  templateUrl: './landing-data.component.html',
  styleUrls: ['./landing-data.component.scss']
})
export class LandingDataComponent implements OnInit, AfterViewInit, OnDestroy {
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(MatPaginator) paginator: MatPaginator;

  @ViewChild('dealerTable', { read: MatSort }) dealerSort: MatSort;
  @ViewChild('dealerPaginator', { read: MatPaginator }) dealerPaginator: MatPaginator;

  @ViewChild('select') select: NgSelectComponent;
  @ViewChild('selectAccountHidden') selectHiddenAcc: ElementRef;
  @ViewChild('selectGrowerHidden') selectHiddengro: ElementRef;
  subscription = new Subscription();
  @ViewChild('growerPaginator', { read: MatPaginator }) growerPaginator: MatPaginator;
  @ViewChild('growerTable', { read: MatSort }) growerSort: MatSort;
  @ViewChild('pdfGenerator') pdfGenerator: GrowerPdfGenerate;


  public headerYear: any;
  public headerCompany = MasterConstants.US_COMPANYCODE;
  public dashboardFilter: DashboardFilter;

  public accountLoading: any;
  public ddlSelectedAccountId: any;
  public accountSearchData: any;
  public accountDataCount = 0;
  public accountNumber: any;
  public accountNameCityState: any;
  public accountBillingType: any;
  public selectedTabIndex = 0;
  userMenuAccessList: any;
  accessTypeMode = false;
  growerAccessTypeMode = false;
  dealerAccessTypeMode = false;
  partnerAccessTypeMode = false;
  licenseAccessTypeMode = false;
  growerLoading: any;
  shipToAccount: number;
  growerList: any;
  searchCount = 0;
  emailAddress: string;
  growerGMK: number;
  isOpenFirst = false;
  isOpenSecond = false;
  selectedGrowerOrderId = 0;

  public growerOrderList: any;
  public growerOrderDataSource: MatTableDataSource<any>;
  public selection = new SelectionModel<GrowerOrderData>(true, []);

  public dealerOrderList: any;
  public dealerOrderDataSource: MatTableDataSource<any>;
  public dealerSelection = new SelectionModel<DealerOrderData>(true, []);

  private pendingLoaderCount = 0;
  public showHidebackDrop = false;
  statusMessage: any = '';
  isMobile = /Android|iPhone|iPad|iPod|Mobile/i.test(window.navigator.userAgent) || window.innerWidth < 768;
  IsMobile = false;
  isInMobileApp = false;
  public licenseTooltipMessageTemplate = '';
  public licenseTooltipMessageCode = '';
  selectedGrowerGMK: number = 0;
  selectedDealerAccount: number = 0;

  constructor(@Inject('BASE_URL') public baseUrl: string,
    private dashboard: DashboardService,
    private broadcastService: BroadcastService,
    private configService: ConfigService,
    private router: Router,
    private loaderService: LoaderService,
    private growerOrderService: GrowerOrderService,
    private toastrService: ToastrService,
    public commonService: CommonService,
    private localStorageService: LocalStorageService,
    private seedReplantService: SeedReplantService,
    private activatedRoute: ActivatedRoute) {
    this.dashboardFilter = new DashboardFilter();
    this.accountLoading = false;
  }

  public getLicenseRedirectUrl(order: any): string {
    const growerOrderNumber = (order?.orderID || order?.growerOrderNumber || '').toString().trim();
    const licenseStatus = 'Unlicensed';
    const route = growerOrderNumber
      ? '/licenses/' + encodeURIComponent(licenseStatus) + '/' + encodeURIComponent(growerOrderNumber)
      : '/licenses/' + encodeURIComponent(licenseStatus);

    return window.location.origin + route;
  }

  private getGrowerLicenseUrl(): string {
    return window.location.origin + '/licenses';
  }

  private loadGrowerLicenseActionMessage(): void {
    const messageCode = (!this.licenseAccessTypeMode || this.IsMobile)
      ? MasterConstants.MESSAGE_GROWER_LICENSE_MISSING_MOBILE
      : MasterConstants.MESSAGE_GROWER_LICENSE_MISSING;

    this.licenseTooltipMessageCode = messageCode;
    this.subscription.add(this.commonService.getMessageConfiguration(messageCode).subscribe((result: any) => {
      this.licenseTooltipMessageTemplate = result?.message || '';
    }, error => {
      LolLoggerService.error(error);
      this.licenseTooltipMessageTemplate = '';
    }));
  }

  public getLicenseTooltipMessageHtml(order: any): string {
    const agcelerateUrl = MasterConstants.AGCELERATE_REGISTRATION_URL;
    const growerLicenseDisplayUrl = this.getGrowerLicenseUrl();
    const growerLicenseRedirectUrl = this.getLicenseRedirectUrl(order);
    let resolvedMessage = this.licenseTooltipMessageTemplate;

    if (!resolvedMessage) {
      return '';
    }

    if (this.licenseTooltipMessageCode === MasterConstants.MESSAGE_GROWER_LICENSE_MISSING_MOBILE) {
      resolvedMessage = resolvedMessage.replace(/\{0\}/g, agcelerateUrl);
    } else {
      resolvedMessage = resolvedMessage.replace(/\{0\}/g, growerLicenseDisplayUrl).replace(/\{1\}/g, agcelerateUrl);
    }

    resolvedMessage = resolvedMessage.replace(/^(\s*)(Action Required:)/i, '$1<strong class="license-action-heading">$2</strong>');

    const urls = resolvedMessage.match(/https?:\/\/\S+/gi) || [];
    if (urls.length > 0) {
      resolvedMessage = resolvedMessage.replace(/https?:\/\/\S+/gi, (url: string) => {
        let trailing = '';
        let cleanUrl = url;
        if (/[.,)]$/.test(url)) {
          trailing = url.slice(-1);
          cleanUrl = url.slice(0, -1);
        }

        if (/\/licenses/i.test(cleanUrl)) {
          return '<a href="' + growerLicenseRedirectUrl + '" class="license-action-link license-nav-link">' + growerLicenseDisplayUrl + '</a>' + trailing;
        }

        return '<a href="' + cleanUrl + '" class="license-action-link external-nav-link">' + cleanUrl + '</a>' + trailing;
      });
    }

    return resolvedMessage;
  }

  public onLicenseTooltipLinkClick(event: MouseEvent): void {
    const target = event.target as HTMLElement;
    const anchor = target?.closest('a.license-action-link') as HTMLAnchorElement;
    if (!anchor) {
      return;
    }

    event.preventDefault();
    const href = anchor.getAttribute('href') || '';
    if (!href) {
      return;
    }

    if (anchor.classList.contains('license-nav-link') || /\/licenses/i.test(href)) {
      const relativeUrl = href.startsWith(window.location.origin)
        ? href.replace(window.location.origin, '')
        : href;
      this.router.navigateByUrl(relativeUrl);
      return;
    }

    window.open(href, '_blank', 'noopener');
  }

  displayedColumns: string[] = ['growerName', 'shipToAccount', 'orderType', 'orderID', 'unit', 'lastUpdatedAt', 'licenseStatus', 'contextMenu']; // 'growerOrderId',
  displayedDealerColumns: string[] = ['retailerName', 'shipToAccount', 'orderId', 'productCount', 'units', 'lastUpdatedAt']; // 'dealerOrderId',

  @HostListener('window:resize', ['$event']) onresize(event) {
    this.setHeight();
    this.setDisplayedColumns();
  }

  // ngOnInit
  ngOnInit() {

    this.isInMobileApp = this.isInWebView();

    if (this.isMobile || this.isInMobileApp || window.innerWidth < 768) {
      this.IsMobile = true;
    }
    // Ensure correct displayedColumns order for desktop and mobile (based on viewport)
    this.setDisplayedColumns();
    // Select all orders
    // submitActionToDTM('evolve:home:selectallOrders', '');
    // Set the default value
    if (this.localStorageService.get(MasterConstants.HEADER_CROP_YEAR)) {
      this.headerYear = JSON.parse(this.localStorageService.get(MasterConstants.HEADER_CROP_YEAR));
    }

    if (this.headerCompany) {
      const evloveAccess = JSON.parse(this.localStorageService.get(MasterConstants.EVOLVE_ACCESS));
      if (evloveAccess) {
        this.userMenuAccessList = evloveAccess.resultData.find(x => x.userIdCompanyCode == this.headerCompany).userMenuAccessList;
        this.accessTypeMode = this.commonService.checkUserRoleAccessType(MasterConstants.FUNCTION_CODE.GROWER_ORDERS_TAB, MasterConstants.USER_ACCESS.READ_ONLY, this.userMenuAccessList);
        this.growerAccessTypeMode = this.commonService.checkUserRoleAccessTypeForMenu(this.userMenuAccessList, MasterConstants.FUNCTION_CODE.GROWER_ORDERS_TAB);
        this.dealerAccessTypeMode = this.commonService.checkUserRoleAccessTypeForMenu(this.userMenuAccessList, MasterConstants.FUNCTION_CODE.DEALER_ORDERS_TAB);
        this.partnerAccessTypeMode = this.commonService.checkUserRoleAccessTypeForMenu(this.userMenuAccessList, MasterConstants.FUNCTION_CODE.PARTNER_WEBSITE);
        this.licenseAccessTypeMode = this.commonService.checkUserRoleAccessTypeForMenu(this.userMenuAccessList, MasterConstants.FUNCTION_CODE.LICENSE_EVOLVE);
      }
    }
    this.loadGrowerLicenseActionMessage();

    this.ddlSelectedAccountId = new Number();
    this.growerOrderDataSource = new MatTableDataSource([]);
    this.growerOrderDataSource.paginator = this.paginator;
    this.growerOrderDataSource.sort = this.sort;

    this.dealerOrderDataSource = new MatTableDataSource([]);
    this.dealerOrderDataSource.paginator = this.dealerPaginator;
    this.dealerOrderDataSource.sort = this.dealerSort;

    if (this.localStorageService.get(MasterConstants.ORDER_TAB_INDEX)) {
      this.selectedTabIndex = +(JSON.parse(this.localStorageService.get(MasterConstants.ORDER_TAB_INDEX)));
    }
    else {
      this.selectedTabIndex = +0;
    }

    if (this.IsMobile) {
      this.subscription.add(this.commonService.seedOrderTabIndex.subscribe(tabIndex => {
        if (tabIndex !== null && tabIndex !== undefined) {
          this.selectedTabIndex = tabIndex;
        }
      }));

      const gmk = this.activatedRoute.snapshot.queryParams['growerGMK'];
      const dealerAccount = this.activatedRoute.snapshot.queryParams['dealerAccount'];
      if (gmk != undefined) {
        this.selectedGrowerGMK = +gmk;
      }

      if (dealerAccount != undefined) {
        this.selectedDealerAccount = +dealerAccount;
      }
    }

    if (!this.IsMobile && this.headerYear && this.headerCompany) {
      this.getAccountDropDownData();
      this.getGrowerOrderData(this.headerYear, this.headerCompany, 0, 0);
      this.getDealerOrderData(this.headerYear, 0);
    }
    else if (this.IsMobile && this.headerYear && this.headerCompany && (this.selectedGrowerGMK > 0 || this.selectedDealerAccount > 0)) {
      this.loadDataForGMKAndDealer();
    }
    else if (this.headerYear && this.headerCompany) {
      this.getAccountDropDownData();
      this.getGrowerOrderData(this.headerYear, this.headerCompany, 0, 0);
      this.getDealerOrderData(this.headerYear, 0);
    }

    this.subscription.add(this.broadcastService.on<any>(this.configService.TAB_INDEX).subscribe((data) => {
      if (data.selectedTabIndex != undefined) {
        this.localStorageService.set(MasterConstants.ORDER_TAB_INDEX, JSON.stringify(data.selectedTabIndex));
        this.router.navigate(['/']);
      }
    }));

    this.localStorageService.set(MasterConstants.ORDER_TAB_INDEX, 0);

    this.subscription.add(this.broadcastService.on<any>(this.configService.ACCESS_TYPE).subscribe((data) => {
      if (this.localStorageService.get(MasterConstants.EVOLVE_ACCESS)
        && data.accessType) {
        setTimeout(x => {
          const evolveAccessData = JSON.parse(this.localStorageService.get(MasterConstants.EVOLVE_ACCESS));
          if (evolveAccessData) {
            this.userMenuAccessList = evolveAccessData.resultData.find(x => x.userIdCompanyCode == this.headerCompany).userMenuAccessList;
            this.accessTypeMode = this.commonService.checkUserRoleAccessType(MasterConstants.FUNCTION_CODE.GROWER_ORDERS_TAB, MasterConstants.USER_ACCESS.READ_ONLY, this.userMenuAccessList);
            this.growerAccessTypeMode = this.commonService.checkUserRoleAccessTypeForMenu(this.userMenuAccessList, MasterConstants.FUNCTION_CODE.GROWER_ORDERS_TAB);
            this.dealerAccessTypeMode = this.commonService.checkUserRoleAccessTypeForMenu(this.userMenuAccessList, MasterConstants.FUNCTION_CODE.DEALER_ORDERS_TAB);
            this.partnerAccessTypeMode = this.commonService.checkUserRoleAccessTypeForMenu(this.userMenuAccessList, MasterConstants.FUNCTION_CODE.PARTNER_WEBSITE);
            this.licenseAccessTypeMode = this.commonService.checkUserRoleAccessTypeForMenu(this.userMenuAccessList, MasterConstants.FUNCTION_CODE.LICENSE_EVOLVE);
            this.loadGrowerLicenseActionMessage();
          }
        }, 500);
      }
    }));
  }

  loadDataForGMKAndDealer() {
    this.accountLoading = true;
    this.dashboardFilter.cropYear = this.headerYear;
    this.subscription.add(this.dashboard.getAccountList().subscribe(result => {
      this.accountSearchData = result;
      this.accountDataCount = this.accountSearchData.length;
      this.accountLoading = false;

      if (this.selectedDealerAccount > 0) {
        this.ddlSelectedAccountId = this.selectedDealerAccount;
        var accountData = this.accountSearchData.filter(x => x.accountNumber == this.ddlSelectedAccountId)[0];

        // if ($event.billingAddressType in MasterConstants.BILLING_ADDRESS_TYPE) {
        this.growerOrderService.AccountChange({
          accountName: accountData.accountName,
          accountNumber: accountData.accountNumber,
          accountType: accountData.accountType,
          billingAddressType: accountData.billingAddressType,
          address1: accountData.address1,
          address2: accountData.address2,
          emailAddress: accountData.emailAddress,
          city: accountData.city,
          state: accountData.state,
          zipCode: accountData.zipCode,
          isAccountRIB: false
        });
        this.dashboardFilter.shipToAccount = accountData.accountNumber;
        this.accountBillingType = accountData.billingAddressType;
        this.shipToAccount = accountData.accountNumber;
        this.emailAddress = accountData.emailAddress;
        if (this.selectedGrowerGMK > 0) {
          //load grower drop down
          this.growerLoading = true;
          this.dashboardFilter.cropYear = this.headerYear;
          this.dashboardFilter.shipToAccount = this.shipToAccount;
          const growerFilters = { 'GrowerGLN': '', 'GrowerName': '' };
          this.subscription.add(this.seedReplantService.getGrowerListByFilter(this.dashboardFilter, growerFilters).subscribe(result => {
            this.growerList = result;
            this.searchCount = this.growerList.length;
            this.growerList.forEach(grower => {
              grower.businessName = (grower.businessName == null || grower.businessName == '' ?
                (grower.firstName != null && grower.firstName != '' ? grower.firstName : '') +
                (grower.middleName != null && grower.middleName != '' ? ' ' + grower.middleName : '') +
                (grower.lastName != null && grower.lastName != '' ? ' ' + grower.lastName : '')
                : grower.businessName);
              grower.EmailTo = this.emailAddress;
            });
            this.growerLoading = false;

            //set the grower gmk
            this.growerGMK = this.selectedGrowerGMK;

            var growerData = this.growerList.filter(x => x.gmk == this.growerGMK)[0];

            if (growerData != undefined) {
              this.growerOrderService.GrowerChange({
                growerName: growerData.growerName,
                address1: growerData.address1,
                city: growerData.city,
                state: growerData.state,
                zip: growerData.zip,
                gmk: growerData.gmk,
                gln: growerData.gln
              });
              this.dashboardFilter.shipToAccount = this.shipToAccount;
              this.dashboardFilter.gMk = growerData.gmk;
            }
            else {
              this.dashboardFilter.gMk = 0;
              this.growerOrderService.GrowerChange(null);
            }
            this.getGrowerOrderData(this.headerYear, this.headerCompany, this.shipToAccount, this.dashboardFilter.gMk);
            this.getDealerOrderData(this.headerYear, this.dashboardFilter.shipToAccount);
            this.growerOrderService.SetAccountState(true);
            setTimeout(() => this.setFocusOut(), 500);
          }, error => {
            this.growerLoading = false;
            this.loaderService.setLoaderStatus(false);
          }));
        }
        else {
          this.getGrowerListByAccount();
          this.getGrowerOrderData(this.headerYear, this.headerCompany, this.dashboardFilter.shipToAccount, 0);
          this.getDealerOrderData(this.headerYear, this.dashboardFilter.shipToAccount);
          this.growerOrderService.SetAccountState(true);
          setTimeout(() => this.setFocusOut(), 500);
        }
      }

    }, error => LolLoggerService.error(error)));
  }

  // ngAfterViewInit
  ngAfterViewInit() {
    // Set Dynamic Height of Panels
    this.setHeight();
    // this.tabChanged();
  }

  // Set displayed columns depending on viewport width (mobile vs desktop)
  setDisplayedColumns() {
    const mobileView = window.innerWidth <= 767;
    if (mobileView) {
      // Mobile: show licenseStatus beside Equiv Units
      this.displayedColumns = ['growerName', 'contextMenu', 'shipToAccount', 'orderType', 'orderID', 'unit', 'licenseStatus', 'lastUpdatedAt'];
    } else {
      // Desktop: keep licenseStatus before context menu and after lastUpdatedAt
      this.displayedColumns = ['growerName', 'shipToAccount', 'orderType', 'orderID', 'unit', 'lastUpdatedAt', 'licenseStatus', 'contextMenu'];
    }
  }

  // Tab changed
  tabChanged = (tabChangeEvent: MatTabChangeEvent): void => {
    if (tabChangeEvent) {
      this.selectedTabIndex = +(tabChangeEvent.index);
    }
    this.setHeight();
  };

  // Set Height
  setHeight() {
    if (window.innerWidth > 767) {
      const templateHeight = window.innerHeight - $('.search-box').outerHeight() - $('.mat-mdc-tab-header').outerHeight() - $('.order-top-sec').outerHeight() - 187;
      $('.growertableContainer').css('max-height', templateHeight + 'px');
      $('.dealertableContainer').css('max-height', templateHeight + 'px');
    }
  }

  // Set focus out
  setFocusOut() {
    // this.select.onInputBlur();
    this.selectHiddenAcc.nativeElement.focus();
    this.selectHiddengro.nativeElement.focus();
  }

  // Open
  onOpen() {
    this.showHidebackDrop = true;
    this.dashboard.isBackDropVisible.next(true);
  }

  // Close
  onClose() {
    this.showHidebackDrop = false;
    this.dashboard.isBackDropVisible.next(false);
  }

  topOpen() {
    this.isOpenFirst = true;
  }
  middleOpen() {
    this.isOpenSecond = true;
  }
  topClose() {
    this.isOpenFirst = false;
  }
  middleClose() {
    this.isOpenSecond = false;
  }

  // Navigate To Single Grower Account
  navigateToSingleAccount(obj: any) {
    if (obj) {
      if (this.ddlSelectedAccountId == null || this.ddlSelectedAccountId == '') {
        this.ddlSelectedAccountId = 0;
      }

      if (this.IsMobile) {
        if (this.ddlSelectedAccountId > 0) {
          this.commonService.setSeedOrderDealerAccount(this.ddlSelectedAccountId);
        }
        if (this.growerGMK > 0) {
          this.commonService.setSeedOrderGrowerGMK(this.growerGMK);
        }
      }

      this.loaderService.setLoaderStatus(true);
      this.router.navigate(['/orders/grower-order-detail', this.ddlSelectedAccountId, obj.growerOrderId]);
      this.loaderService.setLoaderStatus(false);
    }
  }

  // Create new Grower Order
  createNewOrder() {
    if (this.ddlSelectedAccountId == null || this.ddlSelectedAccountId == '') {
      this.ddlSelectedAccountId = 0;
    }
    if ((this.ddlSelectedAccountId != 0 && this.accountBillingType && this.accountBillingType in MasterConstants.BILLING_ADDRESS_TYPE) || this.ddlSelectedAccountId == 0) {
      this.router.navigate(['/orders/grower-order-add', this.ddlSelectedAccountId]);
    }
    else {
      this.toastrService.warning('Account not eligible for Ordering.');
    }
  }

  // Search the account details on Account dropdown
  accountSearchFn(term: string, item: any) {
    term = term.toLocaleLowerCase();
    return item.accountName.toLocaleLowerCase().indexOf(term) > -1
      || item.accountNumber.toString().indexOf(term) > -1
      || item.address1.toLocaleLowerCase().indexOf(term) > -1
      || item.city.toLocaleLowerCase().indexOf(term) > -1
      || item.state.toLocaleLowerCase().indexOf(term) > -1
      || item.zipCode.toLocaleLowerCase().indexOf(term) > -1;
  }

  // Close Action on account Search dropdown
  accountSearchOnClose($event) {
    if ($event != undefined) {
      // if ($event.billingAddressType in MasterConstants.BILLING_ADDRESS_TYPE) {
      this.growerOrderService.AccountChange({
        accountName: $event.accountName,
        accountNumber: $event.accountNumber,
        accountType: $event.accountType,
        billingAddressType: $event.billingAddressType,
        address1: $event.address1,
        address2: $event.address2,
        emailAddress: $event.emailAddress,
        city: $event.city,
        state: $event.state,
        zipCode: $event.zipCode,
        isAccountRIB: false
      });
      this.dashboardFilter.shipToAccount = $event.accountNumber;
      this.accountBillingType = $event.billingAddressType;
      this.shipToAccount = $event.accountNumber;
      this.emailAddress = $event.emailAddress;
      this.getGrowerListByAccount();
      // }
      // else {
      //  this.ddlSelectedAccountId = null;
      //  this.dashboardFilter.shipToAccount = 0;
      //  this.toastrService.warning("Account not eligible for Ordering.");
      // }
    }
    else {
      this.dashboardFilter.shipToAccount = 0;
    }
    this.getGrowerOrderData(this.headerYear, this.headerCompany, this.dashboardFilter.shipToAccount, 0);
    this.getDealerOrderData(this.headerYear, this.dashboardFilter.shipToAccount);
    this.growerOrderService.SetAccountState(true);
    setTimeout(() => this.setFocusOut(), 500);
  }

  // Clear Action on account Search dropdown
  accountSearchOnClear($event) {
    if (this.ddlSelectedAccountId == null || this.ddlSelectedAccountId == '' || this.ddlSelectedAccountId == 0) {
      this.accountBillingType = '';
    }
    this.getGrowerOrderData(this.headerYear, this.headerCompany, 0, 0);
    this.getDealerOrderData(this.headerYear, 0);
    this.growerList = null;
    this.growerGMK = null;
    this.growerOrderService.AccountChange(null);
  }

  // Check box action on Grower Order data
  isAllGrowerOrderSelected() {
    const numSelected = this.selection.selected.length;
    const numRows = this.growerOrderDataSource.data.length;
    return numSelected === numRows;
  }

  // Check box action on Grower Order data
  masterToggleGrower() {
    this.isAllGrowerOrderSelected() ?
      this.selection.clear() :
      this.growerOrderDataSource.data.forEach(row => this.selection.select(row));
  }

  // Check box action on Dealer Order data
  isAllDealerOrderSelected() {
    const numSelected = this.dealerSelection.selected.length;
    const numRows = this.dealerOrderDataSource.data.length;
    return numSelected === numRows;
  }

  // Check box action on Dealer Order data
  masterToggleDealer() {
    this.isAllDealerOrderSelected() ?
      this.dealerSelection.clear() :
      this.dealerOrderDataSource.data.forEach(row => this.dealerSelection.select(row));
  }

  // Navigate to dealer order info
  navigateToDealerOrderInfo(obj: any) {
    if (this.ddlSelectedAccountId == null || this.ddlSelectedAccountId == '') {
      this.ddlSelectedAccountId = 0;
    }

    if (this.IsMobile) {
      if (this.ddlSelectedAccountId > 0) {
        this.commonService.setSeedOrderDealerAccount(this.ddlSelectedAccountId);
      }
      if (this.growerGMK > 0) {
        this.commonService.setSeedOrderGrowerGMK(this.growerGMK);
      }
    }

    let dealerOrderId = 0;
    if (obj.dealerOrderId != null) {
      dealerOrderId = obj.dealerOrderId;
    }
    this.router.navigate(['/orders/dealer-order-view', this.ddlSelectedAccountId, dealerOrderId, obj.shipToAccount]);
  }

  // Get the Grower Order data based on crop year, Company code and shiptoAccount Number
  getGrowerOrderData(cropYear, companyCode, shipToAccount, GMK) {
    this.dashboardFilter.cropYear = cropYear;
    this.dashboardFilter.shipToAccount = shipToAccount;
    this.dashboardFilter.gMk = GMK;
    this.pendingLoaderCount++;
    this.loaderService.setLoaderStatus(true);

    if (this.growerAccessTypeMode) {
      this.subscription.add(this.dashboard.getGrowerOrder(this.dashboardFilter).subscribe(result => {
        this.growerOrderList = result;
        this.growerOrderList.forEach(grower => {
          grower.growerName = (grower.growerName == null || grower.growerName == '' ?
            (grower.firstName != null && grower.firstName != '' ? grower.firstName : '') +
            (grower.middleName != null && grower.middleName != '' ? ' ' + grower.middleName : '') +
            (grower.lastName != null && grower.lastName != '' ? ' ' + grower.lastName : '')
            : grower.growerName);
          grower.showLicenseLoader = true;
        });

        this.growerOrderDataSource = new MatTableDataSource(this.growerOrderList);
        this.growerOrderDataSource.paginator = this.growerPaginator;
        this.growerOrderDataSource.sort = this.growerSort;
        // hide loader and refresh table data so statuses become visible
        setTimeout(() => {
          this.growerOrderList.forEach(g => g.showLicenseLoader = false);
          this.growerOrderDataSource.data = this.growerOrderList;
        }, 500);

        if (this.dashboardFilter.shipToAccount == 0) {
          this.ddlSelectedAccountId = new Number();
        }
        this.pendingLoaderCount--;
        if (this.pendingLoaderCount <= 0) {
          this.pendingLoaderCount = 0;
          this.loaderService.setLoaderStatus(false);
        }
      }, (error => {
        LolLoggerService.error(error);
        this.pendingLoaderCount--;
        if (this.pendingLoaderCount <= 0) {
          this.pendingLoaderCount = 0;
          this.loaderService.setLoaderStatus(false);
        }
      })));
    } else {
      this.pendingLoaderCount--;
      if (this.pendingLoaderCount <= 0) {
        this.pendingLoaderCount = 0;
        this.loaderService.setLoaderStatus(false);
      }
    }
  }

  // Get the account data for account dropdown in Landing Page
  getAccountDropDownData() {
    this.accountLoading = true;
    this.dashboardFilter.cropYear = this.headerYear;
    this.subscription.add(this.dashboard.getAccountList().subscribe(result => {
      this.accountSearchData = result;
      this.accountDataCount = this.accountSearchData.length;
      this.accountLoading = false;
    }, error => LolLoggerService.error(error)));
  }

  // Get the Dealer Order data based on crop year, Company code and shiptoAccount Number
  getDealerOrderData(cropYear, shipToAccount) {
    this.dashboardFilter.cropYear = cropYear;
    this.dashboardFilter.shipToAccount = shipToAccount;
    this.pendingLoaderCount++;
    this.loaderService.setLoaderStatus(true);

    if (this.dealerAccessTypeMode) {
      this.subscription.add(this.dashboard.getDealerOrder(this.dashboardFilter).subscribe(result => {
        this.dealerOrderList = result;

        this.dealerOrderDataSource = new MatTableDataSource(this.dealerOrderList);
        this.dealerOrderDataSource.paginator = this.dealerPaginator;
        this.dealerPaginator.firstPage();
        this.dealerOrderDataSource.sort = this.dealerSort;
        if (this.dashboardFilter.shipToAccount == 0) {
          this.ddlSelectedAccountId = new Number();
        }
        this.setHeight();
        this.pendingLoaderCount--;
        if (this.pendingLoaderCount <= 0) {
          this.pendingLoaderCount = 0;
          this.loaderService.setLoaderStatus(false);
        }
      }, (error => {
        LolLoggerService.error(error);
        this.pendingLoaderCount--;
        if (this.pendingLoaderCount <= 0) {
          this.pendingLoaderCount = 0;
          this.loaderService.setLoaderStatus(false);
        }
      })));
    } else {
      this.pendingLoaderCount--;
      if (this.pendingLoaderCount <= 0) {
        this.pendingLoaderCount = 0;
        this.loaderService.setLoaderStatus(false);
      }
    }
  }


  getGrowerListByAccount() {
    this.growerLoading = true;
    this.dashboardFilter.cropYear = this.headerYear;
    this.dashboardFilter.shipToAccount = this.shipToAccount;
    const growerFilters = { 'GrowerGLN': '', 'GrowerName': '' };
    this.subscription.add(this.seedReplantService.getGrowerListByFilter(this.dashboardFilter, growerFilters).subscribe(result => {
      this.growerList = result;
      this.searchCount = this.growerList.length;
      this.growerList.forEach(grower => {
        grower.businessName = (grower.businessName == null || grower.businessName == '' ?
          (grower.firstName != null && grower.firstName != '' ? grower.firstName : '') +
          (grower.middleName != null && grower.middleName != '' ? ' ' + grower.middleName : '') +
          (grower.lastName != null && grower.lastName != '' ? ' ' + grower.lastName : '')
          : grower.businessName);
        grower.EmailTo = this.emailAddress;
      });
      this.growerLoading = false;
      this.loaderService.setLoaderStatus(false);
    }, error => {
      this.growerLoading = false;
      this.loaderService.setLoaderStatus(false);
    }));
  }

  growerSearchFn(term: string, item: any) {
    if (term) {
      term = term.toLocaleLowerCase();
    }
    return (item.businessName == null ? false : item.businessName.toLocaleLowerCase().indexOf(term) > -1)
      || (item.firstName == null ? false : item.firstName.toLocaleLowerCase().indexOf(term) > -1)
      || (item.lastName == null ? false : item.lastName.toLocaleLowerCase().indexOf(term) > -1)
      || (item.growerGLN == null ? false : item.growerGLN.toString().indexOf(term) > -1)
      || (item.gmk == null ? false : item.gmk.toString().indexOf(term) > -1)
      || (item.address1 == null ? false : item.address1.toLocaleLowerCase().indexOf(term) > -1)
      || (item.city == null ? false : item.city.toLocaleLowerCase().indexOf(term) > -1)
      || (item.state == null ? false : item.state.toLocaleLowerCase().indexOf(term) > -1)
      || (item.zip == null ? false : item.zip.toLocaleLowerCase().indexOf(term) > -1)
      || (item.primaryPhoneNumber == null ? false : item.primaryPhoneNumber.toLocaleLowerCase().indexOf(term) > -1);
  }

  // Serach the data in list and get the serach items count
  search($event) {
    let list: any;
    list = _.filter(this.growerList, item => item.businessName == null ? false : item.businessName.toLocaleLowerCase().indexOf($event) > -1
      || (item.firstName == null ? false : item.firstName.toLocaleLowerCase().indexOf($event) > -1)
      || (item.lastName == null ? false : item.lastName.toLocaleLowerCase().indexOf($event) > -1)
      || (item.growerGLN == null ? false : item.growerGLN.toString().indexOf($event) > -1)
      || (item.gmk == null ? false : item.gmk.toString().indexOf($event) > -1)
      || (item.address1 == null ? false : item.address1.toLocaleLowerCase().indexOf($event) > -1)
      || (item.city == null ? false : item.city.toLocaleLowerCase().indexOf($event) > -1)
      || (item.state == null ? false : item.state.toLocaleLowerCase().indexOf($event) > -1)
      || (item.zip == null ? false : item.zip.toLocaleLowerCase().indexOf($event) > -1)
      || (item.primaryPhoneNumber == null ? false : item.primaryPhoneNumber.toLocaleLowerCase().indexOf($event) > -1));
    this.searchCount = list.length;
  }

  onGrowerSelection($event) {
    if ($event != undefined) {
      this.growerOrderService.GrowerChange({
        growerName: $event.growerName,
        address1: $event.address1,
        city: $event.city,
        state: $event.state,
        zip: $event.zip,
        gmk: $event.gmk,
        gln: $event.gln
      });
      this.dashboardFilter.shipToAccount = this.shipToAccount;
      this.dashboardFilter.gMk = $event.gmk;
    }
    else {
      this.dashboardFilter.gMk = 0;
      this.growerOrderService.GrowerChange(null);
    }
    this.getGrowerOrderData(this.headerYear, this.headerCompany, this.shipToAccount, this.dashboardFilter.gMk);
    setTimeout(() => this.setFocusOut(), 500);
  }
  setSelectedGrowerOrderId(id) {
    this.selectedGrowerOrderId = id;
  }
  generatePdf() {
    this.pdfGenerator.generatePdf();
  }
  ngOnDestroy() {
    if (this.IsMobile) {
      this.commonService.setSeedOrderTabIndex(0);
    }

    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }
  isInWebView(): boolean {
    const ua = navigator.userAgent || '';

    // React Native WebView
    if ((window as any).ReactNativeWebView) return true;

    // iOS WebView: AppleWebKit but NOT Safari
    const isIOS = /iPhone|iPod|iPad/i.test(ua);
    const isIOSWebView = isIOS && /AppleWebKit/.test(ua) && !/Safari/.test(ua);

    // Android WebView: look for 'wv' or no 'Chrome' version string
    const isAndroidWebView = /; wv/.test(ua) || (/Android/.test(ua) && !/Chrome\/\d/.test(ua));

    return isIOSWebView || isAndroidWebView;
  }
}
